import SalesOffice from './SalesOffice'
import RequestType from './RequestType'
export class SalesOfficeRequestType {
    ID: number;
    SalesOfficeID: number;
    RequestTypeID: number;
    IsEnabled: boolean;
    SalesOffice: SalesOffice;
    RequestType: RequestType;
}

export default SalesOfficeRequestType;